// extracted by mini-css-extract-plugin
export default {"header":"styles_header__SBYuU","breadcrumbs":"styles_breadcrumbs__jy00u","title":"styles_title__jhbZ+"};